import ProductSmall from "./ProductSmall";

export default function ProductList({title, items, color, onMessage, onVisible}){
  const hundleUpdateProduct = (id, c) => {
    const idx = items.findIndex(prod => prod.id === id)
    items[idx].inCart = c > 0
    items[idx].cantInCart = c
  }
  return(
    <div className={`catalog-product-content ${color ? color : ''}`}>
      <div className="title-header">
        <div className="title-text-content">
          <div className="title-text large">{title}</div>
        </div>
        <div className="title-border-rounded"></div>
      </div>
      <div className="catalog-product-list">
        {items &&
          items.map((item) => <ProductSmall key={`producto_${item.id}`} product={item} onVisible={onVisible} onMessage={onMessage} updateProduct={hundleUpdateProduct}/>)}
      </div>
    </div>
  )
}